export default {
  BUTTON_PRIMARY_CLASS: 'btn',
  BUTTON_SECONDARY_CLASS: 'btn',

  GARAGE_TITLE: '',
  SEARCH_BOX_CLEAR_BUTTON: 'Clear',
};
